module.exports = __webpack_public_path__ + "static/media/l5.f749eca5.png";